<template>
  <div class="section">
    <div class="column column-1">
      <div class="widget-wrap widget5">
        <WidgetFunnel
          :filtersParams="filtersParams"
        />
      </div>
    </div>

    <div class="column column-2">
      <div class="widget-wrap widget4">
        <WidgetPieChart 
          :filtersParams="filtersParams"
        />
      </div>
    </div>

    <div class="column column-3">
      <div class="widget-wrap widget1">
        <WidgetAverageTime
          :filtersParams="filtersParams"
        />
      </div>
      <div class="widget-wrap widget2">
        <WidgetConversion 
          :filtersParams="filtersParams"
          :filtersPastParams="filtersPastParams"
          :pastDurationMoment="pastDurationMoment"
        />
      </div>
      <div class="widget-wrap widget3">
        <WidgetTotalInterviewDuration 
          :filtersParams="filtersParams"
          :filtersPastParams="filtersPastParams"
          :pastDurationMoment="pastDurationMoment"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WidgetAverageTime from './WidgetAverageTime.vue';
import WidgetConversion from './WidgetConversion.vue';
import WidgetTotalInterviewDuration from './WidgetTotalInterviewDuration.vue';
import WidgetPieChart from './WidgetPieChart.vue';
import WidgetFunnel from './WidgetFunnel.vue';

import Moment from 'moment'

export default {
  components: {
    WidgetAverageTime,
    WidgetConversion,
    WidgetTotalInterviewDuration,
    WidgetPieChart,
    WidgetFunnel
  },

  computed: {
    filtersParams () {
      let after, before
      const f = this.$store.getters['analytics/filters']
      if (f.createdAfter && f.createdAfter.format === undefined) {
        after = Moment(f.createdAfter)
      } else {
        after = f.createdAfter
      }
      if (f.createdBefore && f.createdBefore.format === undefined) {
        before = Moment(f.createdBefore)
      } else {
        before = f.createdBefore
      }
      return {
        vacancy_id: f.vacancy ? f.vacancy.id : null,
        created_after: f.createdAfter ? after.format('YYYY-MM-DD') : null,
        created_before: f.createdBefore ? before.format('YYYY-MM-DD') : null,
        user_email: f.user ? f.user.email : null
      }
    },

    filtersPastParams () {
      const f = JSON.parse(JSON.stringify(this.$store.getters['analytics/filters']))

      const after = Moment(f.createdAfter)
      const before = Moment(f.createdBefore)

      const difference = before && after ? before.diff(after) : null

      // Subtract 1 day because we need compare with past, not with current
      return Object.assign({}, this.filtersParams, {
        created_after: after ? after.subtract(1, 'day').subtract(difference).format('YYYY-MM-DD') : null,
        created_before: before ? before.subtract(1, 'day').subtract(difference).format('YYYY-MM-DD') : null
      })
    },

    pastDurationMoment () {
      const f = JSON.parse(JSON.stringify(this.$store.getters['analytics/filters']))

      const after = Moment(f.createdAfter)
      const before = Moment(f.createdBefore)

      const difference = before && after ? before.diff(after) : null

      return {
        past: {
          after: after.clone().subtract(1, 'day').subtract(difference),
          before: before.clone().subtract(1, 'day').subtract(difference)
        },
        current: { after, before }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .section {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .column-1 {
    flex: 1;
  }

  .column-2 {
    width: 290px;
  }

  .column-3 {
    width: 320px;
  }

  .column {
    margin-right: 15px;

    &:last-child {
      margin-right: 0;
    }
  }

  .widget-wrap {
    margin-bottom: 15px;
  }

  .grid {
    display: grid;
    grid-template-columns:  1fr 290px 320px;
    grid-template-rows: repeat(3, auto);
    grid-column-gap: 15px;
    grid-row-gap: 15px;

    .widget { 
      &1 { grid-area: 1 / 3 / 2 / 4; }
      &2 { grid-area: 2 / 3 / 3 / 4; }
      &3 { grid-area: 3 / 3 / 4 / 4; }
      &4 { grid-area: 1 / 2 / 4 / 3; }
      &5 { grid-area: 1 / 1 / 4 / 1; }
    }

    /* fu***ng IE11 */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      display: -ms-grid;
      -ms-grid-rows: auto 15px auto 15px auto;
      -ms-grid-columns: 320px 15px 290px 15px 1fr;
  
      .widget {
        &1 { 
          -ms-grid-row: 1;
          -ms-grid-column: 5;
        }
        &2 { 
          -ms-grid-row: 3;
          -ms-grid-column: 5;
        }
        &3 { 
          -ms-grid-row: 5;
          -ms-grid-column: 5;
        }
        &4 { 
          -ms-grid-row: 1;
          -ms-grid-column: 3;
          -ms-grid-row-span: 5;
        }
        &5 { 
          -ms-grid-row: 1;
          -ms-grid-column: 1;
          -ms-grid-row-span: 5;
        }
      }
    }
  }
</style>
